exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account_box[data-v-e55a6300]{padding:20px 20px 40px 20px}.title[data-v-e55a6300]{font-size:20px;font-weight:600}.search_criteria[data-v-e55a6300]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.search_criteria>div[data-v-e55a6300]{margin:0 5px;width:180px}.ellipsis-multiline[data-v-e55a6300]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
